// Legal Services specific data for AI Frontdesk
export const lawyersFeatures = [
  // Current Features (Available Now)
  {
    id: "firm-information",
    title: "Law Firm Information",
    description:
      "Answer questions about practice areas, attorney profiles, office hours, and general firm information.",
    icon: "building",
    featured: true,
    status: "current",
    demoScenario: "Client asking about practice areas and consultation availability",
  },
  {
    id: "case-intake",
    title: "Initial Case Intake",
    description:
      "Conduct preliminary case intake interviews, gather essential information, and assess case viability.",
    icon: "clipboard",
    featured: true,
    status: "current",
    demoScenario: "New client inquiry about personal injury case",
  },
  {
    id: "multilingual-legal-support",
    title: "Multilingual Legal Support",
    description:
      "Communicate with clients in Spanish, Mandarin, and other languages with legal terminology accuracy.",
    icon: "globe",
    featured: true,
    status: "current",
    demoScenario: "Spanish-speaking client seeking immigration consultation",
  },

  // Future Features
  {
    id: "document-requests",
    title: "Document Collection & Tracking",
    description:
      "Request, track, and organize client documents needed for case preparation and court filings.",
    icon: "file-text",
    featured: true,
    status: "future",
    demoScenario: "Following up on missing evidence documents",
  },
  {
    id: "court-date-reminders",
    title: "Court Date & Deadline Management",
    description:
      "Automated reminders for court appearances, filing deadlines, and important case milestones.",
    icon: "calendar",
    featured: true,
    status: "future",
    demoScenario: "Reminder call for upcoming court hearing",
    integrations: [
      { name: "Google Calendar", icon: "google-calendar" },
      { name: "Outlook", icon: "outlook" },
      { name: "Apple Calendar", icon: "apple-calendar" },
    ],
  },
  {
    id: "billing-inquiries",
    title: "Billing & Payment Assistance",
    description:
      "Handle billing questions, payment plan arrangements, and invoice clarifications professionally.",
    icon: "credit-card",
    featured: true,
    status: "future",
    demoScenario: "Client inquiring about payment options",
  },
  {
    id: "attorney-routing",
    title: "Intelligent Attorney Routing",
    description:
      "Match clients with the right attorney based on case type, expertise, and availability.",
    icon: "users",
    featured: true,
    status: "future",
    demoScenario: "New client needs specialized attorney for complex case",
  },
  {
    id: "consultation-scheduling",
    title: "Smart Consultation Scheduling",
    description:
      "AI automatically schedules initial consultations, follow-ups, and client meetings with natural conversation.",
    icon: "phone",
    featured: true,
    status: "future",
    demoScenario: "Client booking initial legal consultation",
    integrations: [
      { name: "Calendly", icon: "calendly" },
      { name: "RingCentral", icon: "ringcentral" }
    ],
  },
];

export const lawyersPracticeAreas = [
  {
    id: "personal-injury",
    name: "Personal Injury",
    description: "Car accidents, slip and fall, medical malpractice",
  },
  {
    id: "family-law",
    name: "Family Law",
    description: "Divorce, custody, child support, prenuptial agreements",
  },
  {
    id: "criminal-defense",
    name: "Criminal Defense",
    description: "DUI, theft, assault, drug charges, white collar crimes",
  },
  {
    id: "immigration",
    name: "Immigration",
    description: "Visas, green cards, citizenship, deportation defense",
  },
  {
    id: "estate-planning",
    name: "Estate Planning",
    description: "Wills, trusts, probate, power of attorney",
  },
  {
    id: "business-law",
    name: "Business Law",
    description: "Contract disputes, business formation, commercial litigation",
  },
];

export const lawyersTestimonials = [
  {
    id: 1,
    name: "Michael Thompson, Esq.",
    title: "Managing Partner, Thompson & Associates",
    text: "AI Frontdesk has transformed our intake process. We capture 30% more qualified leads and our attorneys can focus on practicing law instead of answering phones.",
    rating: 5,
    metric: "30% more qualified leads",
  },
  {
    id: 2,
    name: "Jessica Martinez",
    title: "Office Manager, Martinez Legal Group",
    text: "The multilingual support is invaluable. Our Spanish-speaking clients feel heard and understood from the very first call.",
    rating: 5,
    metric: "24/7 multilingual support",
  },
  {
    id: 3,
    name: "David Chen, Esq.",
    title: "Immigration Attorney, Chen Law Firm",
    text: "Never miss an urgent call again. The AI properly prioritizes cases and escalates emergencies to the right attorney immediately.",
    rating: 5,
    metric: "100% call coverage",
  },
];
